<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nyfHZu/tc-custom/9781399061117.jpg?1733110629087" alt="This image is the cover for the book Double Agent Balloon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Double Agent Balloon
      </h1>
      <p class="bookDescription body article font2">
        <p>Dickie Metcalfe was not your typical secret agent, but he was larger than life in more ways than one. Unlike many other agents who were part of the Double Cross System during the Second World War, he did not defect; nor was he blackmailed into becoming a spy. Instead, using his father’s connection with Sir Vernon Kell, the first Director of MI5, Metcalfe volunteered his services.  Recently cashiered from his infantry regiment, he had an ulterior motive – by supplying MI5 with tidbits of information about weapons and arms deals in his newfound profession as an arms dealer, he hoped they would be able to help him get his commission reinstated. Metcalfe became BALLOON, a sub-agent of double agent TRICYCLE’s Yugoslav spy ring.  Concurrent with his spying activities, he collaborated with the co-inventor of the Bren gun to develop a new submachine gun for British forces. After the war, he was also a celebrated motor racing driver and continued to compete until shortly before his death. His success as a double-cross agent in the eyes of both his masters – British and German – is examined in this book, using official documents as a primary source.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Tremain
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77f9023f